import { PdAssistantDialog } from "./pd-assistant-dialog/PdAssistantDialog.js";
//#region src/pd-assistant-dialog/pd-assistant-dialog.ts
var tag = "pd-assistant-dialog";
if (!customElements.get(tag)) customElements.define(tag, PdAssistantDialog);
//#endregion
export { PdAssistantDialog };
